<template>
    <div class="p-fluid">
        <div class="formgrid grid">
            <div class="field col-12 md:col-6 lg:col-3">
                <label>Beat</label>
                <InputText :value="item.beat_code+' - '+item.beat_name" disabled />
            </div>
        </div>
        <div class="formgrid grid">
            <div class="field col-12 md:col-6 lg:col-3">
                <label>User</label>
                <Dropdown id="mcu_id" dataKey="mcu_id" v-model="forms.mcu_id" :loading="loadingDropdownUser"
                    :options="dataDropdownUser" :class="{ 'p-invalid': errorAdd.mcu_id }"
                    optionLabel="label" optionValue="mcu_id" placeholder="Select User" :filter="true"
                    :showClear="true" @filter="searchDropdownUser($event, 'add')"
                />
                <small class="p-invalid" style="color: red" v-if="errorAdd.mcu_id">{{
                    errorAdd.mcu_id[0]
                }}</small>
            </div>
        </div>
    </div>
    <Button :loading="loading" label="Save" icon="pi pi-save" class="p-button-primary" @click="saveNew" />
</template>

<script>

import { mapGetters } from "vuex";

export default {
    emits: ["submit"],
    props: [
		"id",
        "item"
    ],
    data() {
        return {
            // loading
            loading: false,
            loadingDropdownUser: false,

            // dataDropdown,
            dataDropdownUser: null,

            // addNew
            forms: {
                mcu_id: null,
            },
        }
    },
    mounted() {
        this.$store.commit('setErrorAdd', {});
        this.searchDropdownUser('');
    },
    computed:{
        ...mapGetters(['errorAdd']),
    },
    methods: {
        // DROPDOWN
        searchDropdownUser(event, purpose, valueEdit) {
            setTimeout(() => {

                if (valueEdit) {
                    this.$refs.duser.filterValue = valueEdit;
                }

                if (purpose == "add") {
                    this.loadingDropdownUser = true;
                }

                this.axios({
                    method: 'GET',
                    url: process.env.VUE_APP_ROOT_API + 'web/select2/user-hp2',
                    params: {
                        "search": valueEdit ? valueEdit : event.value,
                    }
                })
                .then(res => {

                    if (purpose == "add") {
                        this.dataDropdownUser = res.data.data;
                        this.loadingDropdownUser = false;
                    } else if (purpose == null) {
                        this.dataDropdownUser = res.data.data;
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
            }, 250);
        },
        // ADDNEW
        saveNew() {
            this.loading = true;

            this.axios({
                method: 'POST',
                url: process.env.VUE_APP_ROOT_API + 'web/beat-user/create',
                data: {
                    "beat_id" : this.id,
                    "mcu_id": this.forms.mcu_id,
                },
            })
            .then((res) => {
                this.loading = false;
                if (res) {
                    this.$toast.add({ severity: 'success', summary: 'Successful', detail: 'Data Successfully Saved', life: 3000,});
                    this.$store.commit('setErrors', {});
                    this.$store.commit('setErrorAdd', {});
                    this.clearForms();
                    
                    this.$emit('submit');
                }
            })
            .catch((err) => {
                console.log(err);
                this.loading = false;
                this.$store.commit('setErrorAdd', err.response.data.data ? err.response.data.data : {});
                this.$toast.add({ severity: 'error', summary: 'Failed', detail: 'Data Failed to Saved', life: 3000,});
            });
        },
        clearForms() {
            this.forms.mcu_id = null;
        },
    }
}
</script>